<ion-app>
  <ion-router-outlet id="main" [swipeGesture]="false"></ion-router-outlet>
  <side-menu></side-menu>
</ion-app>
